import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Footer from 'components/Footer';
import { localeChanged, loadSetupActions } from 'actions/dashboard-actions';

const mapStateToProps = ({ setupReducer, localeReducer }, ownProps) => {
  const pathname = ownProps?.location?.pathname || '';
  const isOnScheduleCalendar = pathname === '/schedulecalendar' || pathname === '/';
  return {
    setupActions: setupReducer.setup_actions,
    locale: localeReducer.locale,
    supportedLocales: localeReducer.supportedLocales,
    isOnScheduleCalendar,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onLocaleChange: (locale) => {
      dispatch(localeChanged(locale));
    },
    loadSetupActions(id) {
      dispatch(loadSetupActions(id));
    },
  };
};

const FooterContainer = withRouter(connect(mapStateToProps, mapDispatchToProps)(Footer));

export default FooterContainer;
